"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isServer = isServer;

function isServer() {
  return typeof window === 'undefined';
}


//////////////////
// WEBPACK FOOTER
// ./~/intro.js-react/lib/helpers/server.js
// module id = 62
// module chunks = 0